import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  selectDataParam,
  fetchParam2,
  selectDataParam2,
  fetchDataGroup,
  selectDataGroup,
} from "./paramSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  createChangeHandler,
  getValueStatus,
  optionStatus,
  paramsMasterAll,
  setOptionsMaster,
  showErrorDialog,
} from "../../utility";
import { ParamTable } from "./ParamTable";
import { selectUser } from "../../modules/Auth";
import Select from "react-select";

export const ParamPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const user = useSelector(selectUser);
  const dataGroup = useSelector(selectDataGroup);

  // Filter
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [value, setValue] = useState("");
  const [status, setStatus] = useState("");
  const [optionParam, setOptionParam] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(
        fetchData({ company_id: user.company_id, pageNo: 1, pageSize: 10 })
      );
      await dispatch(fetchDataGroup({ ...paramsMasterAll }));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataGroup.length > 0) {
      setOptionsMaster(
        dataGroup,
        setOptionParam,
        "param_group_name",
        "param_group_name"
      );
    }
  }, [dataGroup]);

  const paramsFilter = {
    company_id: user.company_id,
    param_group_name: name,
    param_code: code,
    param_value: value,
    is_active: status,
  };

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const handleChangeParam = createChangeHandler(setName);
  const handleChangeStatus = createChangeHandler(setStatus);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Param">
        <CardHeaderToolbar>
          {user?.roles[0] === "Super Admin" && (
            <Button
              className="btn btn-danger"
              onClick={() => history.push("/administration/param/create")}
            >
              Create
            </Button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        {/* Filter */}
        <Form className="mb-5">
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Group Name</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionParam}
                    value={getValueStatus(name, optionParam)}
                    placeholder="Select ..."
                    onChange={handleChangeParam}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Is Active</b>
                </Form.Label>
                <Col sm={6}>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={optionStatus}
                    value={getValueStatus(status, optionStatus)}
                    placeholder="Select ..."
                    onChange={handleChangeStatus}
                    isClearable={true}
                  />
                </Col>
              </Form.Group>
            </Col>

            {/* Right Row */}

            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b> Code</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b> Value</b>
                </Form.Label>
                <Col sm={6}>
                  <Form.Control
                    type="text"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Col sm={3}>
                  <Button
                    className="btn btn-outline-danger"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Col>
                {/* <Col sm={3}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
              </Form.Group>
            </Col>
          </Form.Group>
        </Form>

        {/* Table */}
        <ParamTable
          data={Array.isArray(data) ? data : []}
          page={pageNo}
          sizePerPage={pageSize}
          totalSize={totalRecord}
          onTableChange={handleTableChange}
          loading={loading}
        />
      </CardBody>
    </Card>
  );
};
